import { BrandedHeader as BrandedHeaderBase } from '@repo/pdx-ui/BrandedHeader';
import { useIsMobile } from '@repo/dom/hooks/useMediaQuery';
import { useRetailerSettings } from '../../hooks/useRetailerSettings';

export const BrandedHeader = () => {
  const { features } = useRetailerSettings();
  const isMobile = useIsMobile();
  const header = features?.header ?? null;
  const headerHtml = features?.headerHtml ?? null;

  return (
    <BrandedHeaderBase
      header={header}
      headerHtml={headerHtml}
      isMobile={isMobile}
    />
  );
};
